import { combineReducers } from "redux";
import user from "../features/admin/role_permmission/users/Slice";
import roles from "../features/admin/role_permmission/role/Slice";
import broker from "../features/admin/role_permmission/broker/Slice";
import expert from "../features/admin/role_permmission/expert/Slice";
import rental from "../features/admin/role_permmission/rental/Slice";

const customers = combineReducers({
  roles: roles,
  user: user,
  broker: broker,
  expert: expert,
  rental: rental,
});

export default customers;
